import { getCentralizedCalendarConnected as getCentralizedCalendarConnectedSelector } from 'MeetingsAdmin/selectors/CentralizedCalendarSelectors';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Meet... Remove this comment to see the full error message
import { meetingsVerifyError as meetingsVerifyErrorSelector } from 'MeetingsAdmin/selectors/RequestStatusSelector';
import { useIsFreeOrStarterPortal } from 'onboarding-scopes';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { MEETING_TOUR_ID_WITHOUT_CONNECT_CALENDAR, MEETING_TOUR_ID_WITH_CONNECT_CALENDAR } from '../constants/emptyStates';
import { getEmptyStateFlowLocalStorageFlag } from '../utils/emptyStateUtils';
export const useMeetingsTour = () => {
  const [onboardingTourId, setOnboardingTourId] = useState();
  const [isGuidedOnboarding, setIsGuidedOnboarding] = useState(false);
  const isStarterOrFreePortal = useIsFreeOrStarterPortal();
  const userHasSeenOnboardingTour = getEmptyStateFlowLocalStorageFlag();
  const isCentralizedCalendarConnected = useSelector(getCentralizedCalendarConnectedSelector);
  const meetingsVerifyError = useSelector(state => meetingsVerifyErrorSelector(state));
  const shouldShowWithoutCalendarTour = isCentralizedCalendarConnected && !meetingsVerifyError;
  const getTourId = useCallback(() => {
    return shouldShowWithoutCalendarTour ? MEETING_TOUR_ID_WITHOUT_CONNECT_CALENDAR : MEETING_TOUR_ID_WITH_CONNECT_CALENDAR;
  }, [shouldShowWithoutCalendarTour]);
  useEffect(() => {
    if (isGuidedOnboarding && isStarterOrFreePortal && !userHasSeenOnboardingTour &&
    // This to ensure the tourId is not reset when user takes flow to sync calendar during a tour
    !onboardingTourId) {
      setOnboardingTourId(getTourId());
    }
  }, [isGuidedOnboarding, onboardingTourId, isStarterOrFreePortal, userHasSeenOnboardingTour, getTourId]);
  return {
    onboardingTourId,
    isGuidedOnboarding,
    setIsGuidedOnboarding
  };
};